import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getcrmHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "certifiedReferenceMaterial", ...action.payload }),
		);
		yield put({
			type: types.GET_CRM_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CRM_ERROR,
			payload,
		});
	}
}

export function* getcrmWatcherSaga() {
	yield takeLatest(types.GET_CRM_START, getcrmHandlerSaga);
}

//create

//delete

function* deletecrmHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("certifiedReferenceMaterial", action.payload),
		);
		yield put({
			type: types.DELETE_CRM_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_CRM_ERROR,
			payload,
		});
	}
}

export function* deletecrmWatcherSaga() {
	yield takeLatest(types.DELETE_CRM_START, deletecrmHandlerSaga);
}

//update
